import { Filters, SimpleEnumType } from '@/types';
import { UserRoles } from '@/enums';

export namespace CompaniesUsers {
  export enum Pages {
    COMPANIES_USERS_MANAGERS = 'companies-users-managers',
    COMPANY_USER_STAFF = 'company-user-staff',
    COMPANY_USER_STAFF_DETAILS = 'company-user-staff-details',
    COMPANY_USER_STAFF_EDIT = 'company-user-staff-edit',
  }
  export interface CompaniesUsersManagersFilters extends Filters {
    [key: string]: unknown;
    company_id: string[] | number[] | null;
  }

  export interface CompanysUserStaffFilters extends Filters {
    [key: string]: unknown;
    roles: UserRoles.Internal[] | null;
    is_active: boolean | null;
  }

  export interface StaffPayloadAdmin {
    user_id?: number;
    surname: string | null;
    name: string | null;
    patronymic: string | null;
    email: string;
    roles?: UserRoles.Internal[] | SimpleEnumType<UserRoles.Internal>[]; // #TODO: изменить
    is_active?: boolean | null;
    city?:string | null;
    birth_date?: string | null;
  }
  export interface AdminStaffActivationToggle{
    is_active?: boolean,
    title?: string,
    text?: string,
    btn_cancel?: string,
    btn_proceed?: string,
    status?: string,
  }
}
